import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';
import type { BaseViewPageProps } from '@confluence/view-page-common/entry-points/BaseViewPageProps.ts';

export const EmbeddedViewPageLoader: LoadableType<
	BaseViewPageProps & {
		classicComments?: React.ComponentType<any>;
		ClassicEditorContextProviderLoader?: React.ComponentType<any>;
		showHeaderButtons?: boolean;
	}
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-view-pageEmbeddedViewPage" */ '../src/view-page/EmbeddedViewPage.tsx'
			)
		).EmbeddedViewPage,
	_mustPreloadWhenRenderingSPA: [MustPreloadLoadableNames.ViewPageRouteComponentLoader],
});
